import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { ExpandButton } from '../../../components/ExpandButton/index.js';
import { FormattedText } from '../../../components/HotelDescription/components/FormattedText.js';
import { TextBlock } from '../../../components/HotelDescription/components/TextBlock.js';
import { useBooleanToggle } from '../../../hooks/useBooleanToggle/useBooleanToggle.js';
import { Alert, Stack } from '../../../primitives/index.js';
import { CollapsibleContent } from '../../../primitives/CollapsibleContent/index.js';
export const TourOperatorDescription = ({
  tourOperatorDescription,
  curatedDescription
}) => {
  const {
    t
  } = useTranslation('hotelDescription');
  const [isExpanded, handleExpand] = useBooleanToggle();
  if (tourOperatorDescription.length > 0) {
    return _jsx(CollapsibleContent, {
      hiddenContent: _jsx(Stack, {
        children: tourOperatorDescription.map(({
          content
        }, index) => _jsx(FormattedText, {
          dangerouslySetInnerHTML: {
            __html: content
          }
        }, index))
      }),
      expanded: isExpanded,
      minHeight: 200,
      controls: _jsx(ExpandButton, {
        isExpanded: isExpanded,
        onClick: handleExpand,
        translations: {
          showLess: t('showLess'),
          showMore: t('showMore')
        }
      })
    });
  }
  if (curatedDescription.length > 0) {
    return _jsxs(Stack, {
      children: [_jsxs(Alert, {
        variant: "info",
        children: [t('noOperatorDescription.line1'), " ", t('noOperatorDescription.line2')]
      }), _jsx(CollapsibleContent, {
        visibleContent: curatedDescription.slice(0, 1).map(({
          title,
          content
        }, index) => _jsx(TextBlock, {
          title: title,
          content: content
        }, index)),
        hiddenContent: _jsx(Stack, {
          children: curatedDescription.slice(1).map(({
            title,
            content
          }, index) => _jsx(TextBlock, {
            title: title,
            content: content
          }, index))
        }),
        expanded: isExpanded,
        controls: _jsx(ExpandButton, {
          isExpanded: isExpanded,
          onClick: handleExpand,
          translations: {
            showLess: t('showLess'),
            showMore: t('showMore')
          }
        })
      })]
    });
  }
  return _jsx(Alert, {
    variant: "info",
    children: t('noOperatorDescription.line1')
  });
};